<section class="career-information">
  <div class="content">
    <p class="title">Información sobre la carrera</p>
    <div class="description" #firstSection>
      <p>En un contexto de constante cambio y avances tecnológicos, nos adaptamos rápidamente. El contenido de la carrera, la planificación curricular y la modalidad de cada clase se ajusta a las necesidades del mercado actual. Además, trabajamos con buenas prácticas y metodologías, que aplicamos en nuestro trabajo día a día.</p>
      <p>En los 4 años de duración de la carrera vamos a capacitarte en:</p>
      <p class="check-points">
        <img src="../../../assets/icons/check-icon.svg">
        <span>Conocer, aplicar y seleccionar tecnologías adecuadas de desarrollo de  última generación.</span>
      </p>
      <p class="check-points">
        <img src="../../../assets/icons/check-icon.svg">
        <span>Desarrollar software de grado comercial en un entorno colaborativo.</span>
      </p>
      <p class="check-points">
        <img src="../../../assets/icons/check-icon.svg">
        <span>Aplicar las mejores prácticas de la industria del software para el desarrollo.</span>
      </p>
      <p class="sub-title">¿Cómo enseñamos?</p>
      <p>Estudiarás con metodologías orientadas al aprendizaje basado en proyectos, las cuales incluyen:</p>
      <p>- Simulación de problemas de la vida real.</p>
      <p>- Trabajo en equipo, intercambio de ideas y colaboración continua.</p>
      <p>- Creatividad en el proceso.</p>
      <p>- Evaluación y autoevaluación.</p>
      <p>También contarás con una computadora personal provista por Campus del Saber para realizar tu carrera.</p>
      <a href="{{ googleDriveUrl }}" target="_blank">
        <p class="link study-plan">Conoce el plan de estudio y las áreas de especialización.</p>
      </a>
    </div>
  </div>
  <div class="content pre-university-course">
    <p class="title">Segunda convocatoria curso pre-universitario</p>
    <div class="description" #secondSection>
      <p>Participa en el primer curso de admisión 2022.</p>
      <p>Completa el formulario para iniciar el proceso de selección y obtener la beca.</p>
      <a href="{{ faqRedirectUrl }}" target="_blank">
        <p class="link">Para conocer más sobre los requisitos del curso y el proceso de selección ingresa aquí.</p>
      </a>
    </div>
  </div>
  <div class="button-container">
    <a href="{{ formGenericUrl }}" target="_blank">
      <img class="redirect form" src="../../../assets/images/button-form.svg" alt="complete form button">
    </a>
  </div>
</section>
